import {
  CopyIcon,
  DotsThreeVerticalIcon,
  DownloadSimpleIcon,
  EyeIcon,
  PencilSimpleIcon,
  TrashIcon,
} from "@phosphor-icons/react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuPortal,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@reactive-resume/ui";
import { cn } from "@reactive-resume/utils";

import type { DocumentAction } from "../types/document";

type DocumentActionsMenuProps = {
  documentTitle: string;
  onAction: (action: DocumentAction) => void;
};

const standardActions: Array<{
  action: DocumentAction;
  label: string;
  icon: typeof EyeIcon;
}> = [
  {
    action: "open",
    label: "Ouvrir",
    icon: EyeIcon,
  },
  {
    action: "rename",
    label: "Renommer",
    icon: PencilSimpleIcon,
  },
  {
    action: "duplicate",
    label: "Dupliquer",
    icon: CopyIcon,
  },
  {
    action: "download",
    label: "Télécharger",
    icon: DownloadSimpleIcon,
  },
];

export const DocumentActionsMenu = ({ documentTitle, onAction }: DocumentActionsMenuProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label={`Actions pour ${documentTitle}`}
          className={cn(
            "grid size-9 shrink-0 place-items-center rounded-xl",
            "text-indigo-950 transition-colors",
            "hover:bg-indigo-50 hover:text-indigo-700",
            "focus-visible:outline-none focus-visible:ring-2",
            "focus-visible:ring-indigo-500",
          )}
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          <DotsThreeVerticalIcon aria-hidden size={21} weight="bold" />
        </button>
      </DropdownMenuTrigger>

      <DropdownMenuPortal>
        <DropdownMenuContent
          align="end"
          sideOffset={6}
          className="min-w-48 rounded-xl border border-slate-200 bg-white p-1.5 shadow-xl"
        >
          {standardActions.map((item) => {
            const IconComponent = item.icon;

            return (
              <DropdownMenuItem
                key={item.action}
                className={cn(
                  "flex cursor-pointer items-center gap-2.5",
                  "rounded-lg px-3 py-2 text-[13px]",
                  "text-slate-700 outline-none",
                  "focus:bg-indigo-50 focus:text-indigo-700",
                )}
                onSelect={() => {
                  onAction(item.action);
                }}
              >
                <IconComponent aria-hidden size={17} />

                {item.label}
              </DropdownMenuItem>
            );
          })}

          <DropdownMenuSeparator className="my-1 h-px bg-slate-200" />

          <DropdownMenuItem
            className={cn(
              "flex cursor-pointer items-center gap-2.5",
              "rounded-lg px-3 py-2 text-[13px]",
              "text-rose-600 outline-none",
              "focus:bg-rose-50 focus:text-rose-700",
            )}
            onSelect={() => {
              onAction("delete");
            }}
          >
            <TrashIcon aria-hidden size={17} />
            Supprimer
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenuPortal>
    </DropdownMenu>
  );
};
